
import React, { Component } from 'react';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import TableListSort from 'core/TableListSort';
import { DateTimeDisplay, SequenceDisplay} from 'core/Display';
import OrderOpenDetail from "./OrderOpenDetail";


export class OrderTable extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeOrderId: null
    }
  }

  handleOrderOpen = (item, callback) => {
    this.setState({
      activeOrderId: item.id
    });

    callback();
  }

  handleOrderClose = () => {
    this.setState({
      activeOrderId: null
    })
  }

  render() {
    const { items, onDetail } = this.props;
    const { activeOrderId } = this.state;

    return (
      <React.Fragment>
        <TableHead>
          <TableRow>
            <TableCell component="th" scope="row">
              <TableListSort label={'Дата, №'} name={'id'} />
            </TableCell>
            <TableCell component="th" scope="row">Контрагент</TableCell>
            <TableCell component="th" scope="row">Перевозчик</TableCell>
            <TableCell component="th" scope="row">Тариф</TableCell>
            <TableCell component="th" scope="row">Откуда/Куда</TableCell>
            <TableCell component="th" scope="row">Статус/Оплата</TableCell>
            <TableCell component="th" scope="row">Транспорт/Водитель</TableCell>
            <TableCell component="th" scope="row">Контейнер</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {items.map(item =>
          <TableRow
            key={item.id}
            onClick={() => onDetail(item)}
            selected={activeOrderId === item.id}
          >
            <TableCell>
              {item.date_start && <div  className={'mb-3'}><DateTimeDisplay value={item.date_start}  /></div>}
              <OrderOpenDetail orderId={item.id} onClose={() => this.handleOrderClose()}>
                {(openDetail) =>
                  <div onClick={() => this.handleOrderOpen(item, openDetail)}><span className={'link'}>#{item.id}</span></div>
                }
              </OrderOpenDetail>
            </TableCell>
            <TableCell>
              {item.counterparty && item.counterparty.name}
            </TableCell>
            <TableCell>
              {item.carrier && item.carrier.name}
            </TableCell>
            <TableCell>
              {item.tariff_display}
            </TableCell>
            <TableCell>
              {item.points.map(point =>
                <div key={point.id}>{point.point_display}</div>
              )}
            </TableCell>
            <TableCell>
              <div className={'mb-3'}>{item.order_status ? item.order_status.label : '-'}</div>
              <div>{item.order_payment_status ? item.order_payment_status.label : '-'}</div>
            </TableCell>
            <TableCell>
              <SequenceDisplay values={[
                item.tractor_unit_display,
                item.driver_display,
                item.semi_trailer_display
              ]} separator={', '} />
            </TableCell>
            <TableCell>
              {item.container_number || '-'}
            </TableCell>
          </TableRow>
        )}
        </TableBody>
      </React.Fragment>
    )
  }
}
